<script>
import RubricCriteriaExpandButton from "./RubricCriteriaExpandButton.vue";

export default {
  name: "ExpandableTextarea",
  components: { RubricCriteriaExpandButton },
  props: {
    value: {
      type: String,
      default: "",
    },
    canValidate: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  data() {
    return {
      overscroll: false,
      expanded: false,
    };
  },
  computed: {
    showButton() {
      return this.expanded || this.overscroll;
    },
  },
  mounted() {
    this.updateSize();
  },
  methods: {
    updateSize() {
      const textareaComponent = this.$refs.textarea;
      const inner = textareaComponent?.$refs?.inner;
      const host = textareaComponent?.$el;

      if (!inner || !host) return;

      this.overscroll = inner.scrollHeight > inner.clientHeight;
      if (this.overscroll) {
        host.style.setProperty("--height", `${inner.scrollHeight + 10}px`);
      }
    },
    onTextUpdate(value) {
      this.$emit("change", value);
      this.$nextTick(() => {
        this.updateSize();
      });
    },
  },
};
</script>

<template>
  <div :class="['textarea-wrapper', { expanded }]">
    <eg-input
      ref="textarea"
      variant="textarea"
      size="small"
      :placeholder="`Enter the requirements the student needs to demonstrate to get this grade.\n\nEx: Supports the central claim and reasons with strong facts, thorough details, and accurate citations.`"
      :class="['grade-explanation', 'pale-placeholder', { expanded }]"
      :state="
        canValidate
          ? value?.trim().length > 0
            ? 'success'
            : 'error'
          : 'default'
      "
      :value="value"
      :rows="3"
      @input="onTextUpdate"
    />
    <div>
      <RubricCriteriaExpandButton
        v-if="showButton"
        :value="expanded"
        @click="
          expanded = !expanded;
          $nextTick(() => updateSize());
        "
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.textarea-wrapper {
  height: 100%;
  position: relative;
  &.expanded {
    z-index: 1;
    ::v-deep .expand-button {
      right: 2px;
    }
  }
}

.grade-explanation {
  height: 100%;
  transition: box-shadow 0.15s ease-out;
  ::v-deep .eg-input__control {
    height: 100%;
    textarea {
      height: 100%;
    }
  }
  .eg-input__inner {
    height: 100%;
    resize: none;
  }
  &.expanded {
    height: var(--height) !important;
    position: absolute;
    width: 100%;

    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 12%) 0 0 4px 4px, rgb(0 0 0 / 8%) 0 0 2px 2px;
  }
}
</style>
